import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import CustomNavbar from "./CustomPermissions/CustomNavbar";
import { getApiUrl, API_ENDPOINTS } from "../config/api";

const CreateRecord = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    password: "",
    username: "",
    resume_forwarded: 0,
    pipline: 0,
    selected: 0,
    target: 0,
    revenue: 0,  // Target Revenue field
    turned_up: 0,
    image: null,
    role: "hr", // Always create HR Associates from this page
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
  };

  useEffect(() => {
    // Check if the user is a superuser
    const superuserStatus = localStorage.getItem("is_superuser") === "true";
    setIsSuperuser(superuserStatus);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      let value = formData[key];
      if (key === "username" && typeof value === "string") {
        value = value.trim();
      }
      formDataToSend.append(key, value);
    });

    try {
      await axios.post(getApiUrl(API_ENDPOINTS.CREATE_RECORD), formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      navigate("/records"); // Redirect on success
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Check if there's a single error message
        if (errorData.error || errorData.message) {
          setErrorMessage(errorData.error || errorData.message);
        } else {
          // Handle multiple field errors
          const errorMessages = Object.keys(errorData)
            .map((key) => {
              const value = errorData[key];
              // Check if value is an array
              if (Array.isArray(value)) {
                return `${key}: ${value.join(", ")}`;
              }
              // If it's a string or other type
              return `${key}: ${value}`;
            })
            .join("\n");
          setErrorMessage(errorMessages);
        }
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <CustomNavbar />
        <div
          style={{
            width: "100vw",
            maxHeight: "100vh",
            overflowY: "scroll",
            marginBottom: "15px",
            paddingBottom: "30px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "70px",
              // background: "var(--bg-blue)",
            }}
            className="bg-blue-500"
          >
            <h3
              style={{
                color: "white",
                paddingTop: "15px",
                paddingLeft: "25px",
              }}
            >
              Add HR Associate
            </h3>
          </div>
          {errorMessage && (
            <div className="bg-red-200 text-blue-700 border border-red-600 px-4 py-3 rounded-md my-4">
              {errorMessage}
            </div>
          )}
          <div
            className="container mx-auto"
            style={{ width: "90%", margin: "auto", marginTop: "35px" }}
          >
            <div
              className="container"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Link
                to="/records"
                style={{
                  marginTop: "8px",
                  // border: "1px solid blue",
                  padding: "15px",
                  borderRadius: "7px 15px",
                  color: "white",
                }}
                className="bg-blue-500"
              >
                All Records
              </Link>
            </div>

            <form
              onSubmit={handleSubmit}
              method="post"
              encType="multipart/form-data"
              style={{ marginTop: "20px" }}
            >
              {/* Info message for clarity */}
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-blue-700">
                      This page creates <strong>HR Associates</strong> only. To create other user types (Docladder, Team Leader, Regular User), use the <strong>User Management</strong> page.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "20px",
                }}
              >
                {[
                  { label: "Name", name: "name", type: "text" },
                  { label: "Username", name: "username", type: "text" },
                  { label: "Password", name: "password", type: "password" },
                  {
                    label: "Resumes Forwarded",
                    name: "resume_forwarded",
                    type: "number",
                  },
                  { label: "Pipeline", name: "pipline", type: "number" },
                  { label: "Turned Up", name: "turned_up", type: "number" },
                  { label: "Selected", name: "selected", type: "number" },
                  { label: "Target", name: "target", type: "number" },
                  { label: "Target Revenue (in lacs)", name: "revenue", type: "number", step: "0.01" },
                  { label: "Upload Image", name: "image", type: "file" },
                ].map((field, index) => (
                  <div key={index}>
                    <label
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      htmlFor={field.name}
                    >
                      {field.label}
                    </label>
                    <input
                      className="block w-full px-4 py-2 text-sm text-gray-700 bg-white border rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      id={field.name}
                      name={field.name}
                      type={field.type}
                      step={field.step || undefined}
                      value={
                        field.type !== "file" ? formData[field.name] : undefined
                      }
                      onChange={
                        field.type !== "file" ? handleChange : handleImageChange
                      }
                      required
                    />
                  </div>
                ))}
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring"
                  // style={{ background: "var(--bg-blue)" }}
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRecord;
